import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaPersonWalkingLuggage, FaSuitcase } from "react-icons/fa6";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_LEAVE } from "variables/constants";
import LeaveRequests from "./index";

const leavesRequestRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Leave Requests",
		basePath: "leave-requests",
		mainComponent: <LeaveRequests />,
	    layout: "/console",	   
	    icon: <FaPersonWalkingLuggage className="icon-item" />,
	    subTitle:"Leave Request",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:5,
		moduleId: MODULE_LEAVE,
	})
]

export default leavesRequestRoutes;